var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatarLeftWSlide(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1116,
    height: 627,
    viewBox: "0 0 1116 627",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151 454.5C173.884 454.5 195.832 445.413 212.013 429.238C228.195 413.063 237.286 391.125 237.286 368.25C237.286 345.375 228.195 323.437 212.013 307.262C195.832 291.087 173.884 282 151 282C128.116 282 106.168 291.087 89.9868 307.262C73.8051 323.437 64.7143 345.375 64.7143 368.25C64.7143 391.125 73.8051 413.063 89.9868 429.238C106.168 445.413 128.116 454.5 151 454.5ZM120.193 486.844C53.7938 486.844 0 540.615 0 606.987C0 618.038 8.96563 627 20.021 627H281.979C293.034 627 302 618.038 302 606.987C302 540.615 248.206 486.844 181.807 486.844H120.193Z",
    fill: "#C5C5C5"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 402,
    width: 714,
    height: 402,
    rx: 33,
    fill: "#C5C5C5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 302,
    height: 345,
    fill: "white",
    transform: "translate(0 282)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarLeftWSlide);
export default __webpack_public_path__ + "static/media/avatar-left-w-slide.67162adfa4edec57f08988326656ac77.svg";
export { ForwardRef as ReactComponent };